import { NgClass } from "@angular/common";
import {
    Component,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    OnDestroy,
    Output,
    Renderer2,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "rask-radiobutton",
    styleUrls: ["./radiobutton.component.scss"],
    templateUrl: "./radiobutton.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class RadiobuttonComponent implements OnDestroy {
    @Input() checked?: boolean;
    @Output() checkedChange = new EventEmitter();
    @Input() disabled?: boolean;
    focused = false;
    @Input() key: any;
    @Input() label: string;
    @Input() negative?: boolean;
    @HostBinding("class.small") @Input() small?: boolean = false;

    @Input() onBeforeChange: ($event: any) => Observable<boolean>;
    keyDownUnsubscriber: () => void;

    keyUpUnsubscriber: () => void;

    private readonly destroy$ = new Subject<void>();
    private readonly renderer2 = inject(Renderer2);

    @HostBinding("attr.disabled") get getDisabledState() { return (this.disabled ? "" : null);}

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onBlurInput() {
        //Unsubscribar till alla keyevents
        this.focused = false;
        this.keyDownUnsubscriber();
        this.keyDownUnsubscriber = null;
        this.keyUpUnsubscriber();
        this.keyUpUnsubscriber = null;
    }

    @HostListener("click") onClick() {
        if (this.disabled) {
            return;
        }

        if (!this.onBeforeChange) {
            this.checked = true;
            this.checkedChange.emit(this.key);
        } else {
            this.onBeforeChange(this.key).pipe(
                takeUntil(this.destroy$)
            ).subscribe(result => {
                if (result) {
                    this.checked = true;
                    this.checkedChange.emit(this.key);
                }
            });
        }
    }

    onFocusInput() {
        this.focused = true;
        // Lyssnar på keyDown enbart om vi har focus, om "this" är FOCUS och INTE DISABLED samt att key är
        // ett SPACE så stoppar vi ordinarie hantering av eventet = för att förhindra att sidan skrollar
        this.keyDownUnsubscriber = this.renderer2.listen(window, "keydown", (event: KeyboardEvent) => {
            if (this.shouldKeyBeHandled(event)) {
                this.stopKeyEventBubble(event);
            }
        });
        // Lyssnar på keyUp enbart om vi har focus, om "this" är FOCUS och INTE DISABLED samt att key är
        // ett SPACE så stoppar vi ordinarie hantering av eventet = för att toggla this.checked state
        this.keyUpUnsubscriber = this.renderer2.listen(window, "keyup", (event: KeyboardEvent) => {
            if (this.shouldKeyBeHandled(event)) {
                this.stopKeyEventBubble(event);
                this.onClick();
            }
        });
    }

    shouldKeyBeHandled(event: KeyboardEvent) {
        if (this.disabled) {
            return false;
        }
        if (!this.focused) {
            return false;
        }

        if (event.key === " ") {
            return true;
        }
        return false;
    }

    stopKeyEventBubble(event: KeyboardEvent) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.preventDefault();
    }
}
